export default "__VITE_ASSET__baf46641__"